import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { BaseService } from './base.service';
import { ImagePackage, ImagePackageComments } from '../models/image-package.model';

@Injectable()
export class ImagePackageService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getImagePackage(patientId: string, visitId?: string): Promise<ImagePackage> {
    if (visitId) {
      return this.get('imagePackage/' + patientId + '/' + visitId);
    }
    else {
      return this.get('imagePackage/' + patientId);
    }
  }

  async updateImagePackage(imagePackage: ImagePackage, patientId: string, visitId: string, studyId: string): Promise<ImagePackage> {
    return this.post('imagePackage/' + patientId + '/' + visitId + '/' + encodeURIComponent(studyId), imagePackage);
  }

  async getImagePackageComments(imagePackageId: number): Promise<ImagePackageComments> {
    return this.get('imagePackage/comments/' + imagePackageId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/image-package.service.ts